import { Customer } from 'types';
import fetchWithRetry from './fetch-retry';

export const getCustomers = async (): Promise<Customer[]> =>
  await fetchWithRetry<Customer[]>('/api/customers?includeDeactivated=false&embed=locations', { method: 'GET' }, []);

